import OutboundFollowUpsModelMC from '../presentation/models/OutboundFollowUpsModelMC';

const getCsrfToken = () => document.querySelector('[name="csrf-token"]')?.content;

export const getOutboundFollowUpConfig = () => (dispatch) => {
  dispatch({ type: 'OUTBOUND_FOLLOW_UP/LOADING' });
  OutboundFollowUpsModelMC.getConfig()
    .then((data) => dispatch({ type: 'OUTBOUND_FOLLOW_UP/LOADED', data }))
    .catch(() => dispatch({ type: 'OUTBOUND_FOLLOW_UP/FETCH_ERROR' }));
};

export const updateOutboundFollowUpConfig = (body) => (dispatch) => {
  dispatch({ type: 'OUTBOUND_FOLLOW_UP/SAVING' });
  OutboundFollowUpsModelMC.updateConfig(body, getCsrfToken())
    .then((data) => dispatch({ type: 'OUTBOUND_FOLLOW_UP/SAVED', data }))
    .catch((err) => dispatch({
      type: 'OUTBOUND_FOLLOW_UP/SAVE_ERROR',
      payload: err?.message || 'Error guardando configuración'
    }));
};

export const resetSaved = () => ({ type: 'OUTBOUND_FOLLOW_UP/RESET_SAVED' });
